var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{tag: true, tag_dark: _vm.dark},style:({
  color: _vm.color && _vm.color.text,
  backgroundColor: _vm.color && _vm.color.background
})},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }